(function () {
  if (window.__salePopupInitialized) return;
  window.__salePopupInitialized = true;

  const DRAWER_ID = "sale-popup-drawer";
  const DRAWER_CONTENT_ID = "sale-popup-drawer-content";
  const DEFAULT_KEY = "buy-more-save-more";

  // Content is rendered by sale-popup.liquid from sales_service_item metaobjects.
  // Entry keys, not titles or list positions, connect each trigger to its panel.
  const setAccordionItemState = (item, isActive) => {
    item.classList.toggle("is-active", isActive);
    item.querySelector("[data-sale-popup-accordion-trigger]")?.setAttribute("aria-expanded", String(isActive));
    item.querySelector("[data-sale-popup-panel]")?.classList.toggle("is-active", isActive);
  };

  const registerDrawer = () => {
    const drawer = document.getElementById(DRAWER_ID);
    if (!window.themeDrawer || !drawer) return null;

    if (drawer.dataset.salePopupRegistered !== "true") {
      window.themeDrawer.register(DRAWER_ID, { position: "right" });
      drawer.dataset.salePopupRegistered = "true";

      drawer.addEventListener("click", (event) => {
        if (event.target.closest("[data-sale-popup-close]")) {
          window.themeDrawer.close(DRAWER_ID);
          return;
        }
        const trigger = event.target.closest("[data-sale-popup-accordion-trigger]");
        const item = trigger?.closest("[data-sale-popup-item]");
        if (item) setAccordionItemState(item, trigger.getAttribute("aria-expanded") !== "true");
      });
      document.getElementById(`${DRAWER_ID}-overlay`)?.addEventListener("click", () => window.themeDrawer.close(DRAWER_ID));
    }

    return drawer;
  };

  // Public API: salePopup.open('shipping'); the default is the promotion entry.
  // Read current DOM on every open so editor replacements and reordering work.
  const open = (initialKey = DEFAULT_KEY) => {
    const drawer = registerDrawer();
    const content = drawer?.querySelector(`#${DRAWER_CONTENT_ID}`);
    if (!content) return null;

    const items = Array.from(content.querySelectorAll("[data-sale-popup-item]"));
    const activeItem = items.find((item) => item.dataset.salePopupItem === initialKey) || items[0];
    items.forEach((item) => setAccordionItemState(item, item === activeItem));
    content.scrollTop = 0;
    window.themeDrawer.open(DRAWER_ID);
    return window.themeDrawer.drawers[DRAWER_ID];
  };

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-sale-popup-trigger], [data-announcement-sale-trigger]");
    if (!trigger) return;

    if (open(trigger.dataset.salePopupTrigger || DEFAULT_KEY)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  registerDrawer();
  document.addEventListener("DOMContentLoaded", registerDrawer);
  document.addEventListener("shopify:section:load", registerDrawer);
  document.addEventListener("shopify:section:unload", (event) => {
    const drawer = document.getElementById(DRAWER_ID);
    if (drawer && event.target.contains(drawer) && window.themeDrawer?.drawers[DRAWER_ID]?.isOpen) {
      window.themeDrawer.close(DRAWER_ID);
    }
  });

  window.salePopup = { open };
})();
